import Image from "next/image";

import { Button } from "react-bootstrap";
import arrowRight2 from "../../assets/icons/arrow-right-half-white.svg";
import styles from "./ParentPageNotFound.module.css";
import SEO from "../../components/Seo";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { parentPageNotFoundData } from "@/utils/mapping";

const ParentPageNotFound = () => {
  const router = useRouter();
  const {parentPageNotFound} = useSelector((state:any)=>state?.data);

  const processedData = parentPageNotFoundData(parentPageNotFound);


  const handleClick = (e: any, href: string) => {
    e.preventDefault();
    router.push(href);
  };


  return (
    <>
    <div className="formGap1"></div>
    <div className="container" data-testid="pnf-container-id">
      <SEO />
      <div>
        <Image
          src={processedData?.relatedmedia?.fileUrl}
          alt="page-not-found"
          width={405}
          height={375}
        />
      </div>
      <h3 className={`${styles.title}`}>{processedData?.title}</h3>
      <h6 className={`${styles.descs}`}>{processedData?.description}</h6>
      <div className={styles.main_btn}>
        <a
          onClick={(e) => handleClick(e, processedData?.exploreMoreLink)}
          className={styles.links}
        >
          <Button
            variant="outline-secondary"
            className={`${styles.btnExplore}`}
          >
            {processedData?.exploreMore}
          </Button>
        </a>
        {processedData?.findRightOne ||
          (processedData?.findRightOne !== undefined && (
            <a
              className={styles.links}
              onClick={(e) => handleClick(e, `/education/product/comparison`)}
            >
              <Button
                variant="outline-secondary"
                className={`${styles.btnOrange}`}
              >
                {processedData?.findRightOne}
               
                <Image
                  className={` ${styles.bannerBtnArrow}`}
                  src={arrowRight2}
                  alt="arrow-right"
                  height={24}
                  width={24}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </Button>
            </a>
          ))}
      </div>
    </div>
    </>
  );
};

export default ParentPageNotFound;
